export default __webpack_public_path__ + "static/broadcastImg1-070e43bfb6c43d1a6bf788ad78b0bffc.webp";